module.exports = __webpack_public_path__ + "static/media/registerOwner.7430d6f9.png";